import * as toastr from '../../../node_modules/toastr/build/toastr.min.js';
import * as redirectServices from 'services/url/redirectServices';
import * as cookieServices from 'services/cookies/cookieServices';
/** non posso usare il translate di react perchè questo non è un componente */
var I18n = require('react-redux-i18n').I18n;

export function handleUnauthorized() {
   cookieServices.deleteAppCookie();
   cookieServices.deleteJasperSessionCookie();
   cookieServices.deleteLanguageCodeCookie();
   toastr.error(I18n.t('GLOBAL.notAuthorized'));
   redirectServices.redirectToLogin();
}

/**
 * Handles 'Ok' status code
 * @param {} localResponse Response
 */
export function handleOperationOk(localResponse) {

    //Arguments validation
    if (!localResponse) throw new Error("Argument 'localResponse' is invalid");

    //if status code is not 200, exit
    if (localResponse.status !== 200)
        return;

    //Rise alert using toast
    toastr.success(I18n.t('GLOBAL.operationSuccess'));
}

export function handleEntityCreated(localResponse) {

    //Arguments validation
    if (!localResponse) throw new Error("Argument 'localResponse' is invalid");

    //if status code is not 201, exit
    if (localResponse.status !== 201)
        return;

    //Rise alert using toast
    toastr.success(I18n.t('GLOBAL.operationSuccess'));
}

export function handleEntityalreadyExists(localResponse) {

    //Arguments validation
    if (!localResponse) throw new Error("Argument 'localResponse' is invalid");

    //if status code is not 409, exit
    if (localResponse.status !== 409)
        return;

    //Rise alert using toast
    toastr.success(I18n.t('GLOBAL.entityexisting'));
}

/**
 * Handles 'NotFound' status code
 * @param {} localResponse Response
 */
export function handleOperationNotFound(localResponse) {

    //Arguments validation
    if (!localResponse) throw new Error("Argument 'localResponse' is invalid");

    //if status code is not 404, exit
    if (localResponse.status !== 404)
        return;

    //Rise alert using toast
    toastr.warning(I18n.t('GLOBAL.notFound'));
}

/**
 * Handles User 'Forbidden - Locked' status code
 * @param {} localResponse Response
 */
export function handleUserLocked(localResponse) {

    //Arguments validation
    if (!localResponse) throw new Error("Argument 'localResponse' is invalid");

    //if status code is not 403, exit
    if (localResponse.status !== 403)
        return;

    //Rise alert using toast
    toastr.warning(I18n.t('Messages.userLocked'));
}

/**
 * Handles User 'NotFound' status code
 * @param {} localResponse Response
 */
export function handleUserNotFound(localResponse) {

    //Arguments validation
    if (!localResponse) throw new Error("Argument 'localResponse' is invalid");

    //if status code is not 404, exit
    if (localResponse.status !== 404)
        return;

    //Rise alert using toast
    toastr.warning(I18n.t('Messages.userNotFound'));
}

/**
 * Handles 'Unauthorized' status code
 * @param {} localResponse Response
 */
export function handleOperationUnauthorized(localResponse) {

    //Arguments validation
    if (!localResponse) throw new Error("Argument 'localResponse' is invalid");

    //if status code is not 401, exit
    if (localResponse.status !== 401)
        return;

    handleUnauthorized();
}

/**
 * Handles User 'Unauthorized' status code
 * @param {} localResponse Response
 */
export function handleUserUnauthorized(localResponse) {

    //Arguments validation
    if (!localResponse) throw new Error("Argument 'localResponse' is invalid");

    //if status code is not 401, exit
    if (localResponse.status !== 401)
        return;

    toastr.error(I18n.t('Messages.wrongUsernameOrPwd'));
}

/**
* Handles 'Not authorized for this operation' status code 403
* @param {} localResponse Response
*/
export function handleUnauthorizedOnOperation(localResponse) {

    //Arguments validation
    if (!localResponse) throw new Error("Argument 'localResponse' is invalid");

    //if status code is not 403, exit
    if (localResponse.status !== 403)
        return;

    //Rise alert using toast
    toastr.error(I18n.t('GLOBAL.unauthorizedOnOperation'));
    handleUnauthorized();
}

/**
 * Handles 'Association expansion error' status code 417
 * @param {} localResponse Response
 */
export function handleAssociationExpansionError(localResponse) {

    //Arguments validation
    if (!localResponse) throw new Error("Argument 'localResponse' is invalid");

    //if status code is not 417, exit
    if (localResponse.status !== 417)
        return;

    //Rise alert using toast
    toastr.error(I18n.t('GLOBAL.associationExpansionError'));
}

/**
 * Handles 'internalServerError' status code
 * @param {} localResponse Response
 */
export function handleInternalServerError(localResponse) {

    //Arguments validation
    if (!localResponse) throw new Error("Argument 'localResponse' is invalid");

    //if status code is not 500, exit
    if (localResponse.status !== 500 && localResponse.status !== -1)
        return;

    //Rise alert using toast
    toastr.error(I18n.t('GLOBAL.serverError'));
}

/**
 * Handles 'ServiceNotAvailable' status code 503
 * @param {} localResponse Response
 */
export function handleServiceNotAvailable(localResponse) {

    //Arguments validation
    if (!localResponse) throw new Error("Argument 'localResponse' is invalid");

    //if status code is not 503, exit
    if (localResponse.status !== 503)
        return;

    //Rise alert using toast
    toastr.error(I18n.t('GLOBAL.serverError'));
}

/**
 * Handles 'BadRequest' status code
 * @param {} localResponse Response
 */
export function handleOperationBadRequest(localResponse) {

    //Arguments validation
    if (!localResponse) throw new Error("Argument 'localResponse' is invalid");

    //if status code is not 400, exit
    if (localResponse.status !== 400)
        return;

    //If property "modelState" does not exists
    if (!localResponse.data.modelState) {

        //Show generic message
        toastr.warning(I18n.t('GLOBAL.badRequest'));
    }
    else {

        //Generate message
        var message = "Provided data is invalid:";

        //Iterate over all properties
        for (var currentPropertyName in localResponse.data.modelState) {

            //If it's not his property
            if (!localResponse.data.modelState.hasOwnProperty(currentPropertyName))
                continue;

            //Get property value
            var propertyValue = localResponse.data.modelState[currentPropertyName];

            //If property is owned by element
            if (propertyValue) {
                var temp;

                temp = propertyValue.join("<br/>");

                message = message + '<br/>' + temp;
            }
        }
    }
}

/**
 * Handles server response
 * @param {} response Response
 */
export function handleOperationResponse(response) {

    if (!response) throw new Error("Argument 'response' is invalid");

    //Trace instance of current function
    //and set instance of response
    var self = this;
    self.response = response;
    self.handledStates = [];

    //Handle for 'Ok'
    self.ok = function () {
        self.handledStates.push(handleOperationOk);
        return self;
    };

    self.entityCreated = function () {
        self.handledStates.push(handleEntityCreated);
        return self;
    };

    self.entityalreadyExists = function () {
        self.handledStates.push(handleEntityalreadyExists);
        return self;
    };

    //Handle for 'Badrequest'
    self.badRequest = function () {
        self.handledStates.push(handleOperationBadRequest);
        return self;
    };

    //Handle for 'NotFound'
    self.notFound = function () {
        self.handledStates.push(handleOperationNotFound);
        return self;
    };

    //Handle for 'Unauthorized'
    self.unauthorized = function () {
        self.handledStates.push(handleOperationUnauthorized);
        return self;
    };

    // 403 - Not authorized for this operation.
    self.unauthorizedOnOperation = function () {
        self.handledStates.push(handleUnauthorizedOnOperation);
        return self;
    };
    //Handle for 'InternalServerError'
    self.internalServerError = function () {
        self.handledStates.push(handleInternalServerError);
        return self;
    };

    //Handle for 'serviceNotAvailable'
    self.serviceNotAvailable = function () {
        self.handledStates.push(handleServiceNotAvailable);
        return self;
    };

    self.associationExpansionError = function () {
        self.handledStates.push(handleAssociationExpansionError);
        return self;
    };

    //Handle all
    self.all = function () {
        self.ok();
        self.entityCreated();
        self.entityalreadyExists();
        self.badRequest();
        self.notFound();
        self.unauthorized();
        self.internalServerError();
        self.serviceNotAvailable();
        self.unauthorizedOnOperation();
        self.associationExpansionError();
        return self;
    }

    //Execute pipeline
    self.pipe = function () {
        //Iterate each queued function
        for (var i = 0; i < self.handledStates.length; i++) {

            //Get current function
            var currentFunc = self.handledStates[i];

            //Invoke passing "response"
            currentFunc(self.response);
        }
    }

    //Returns self
    return self;
}

/**
 * Handles server response. ignore not found
 * @param {} response Response
 */
export function handleOperationResponseButNotFound(response) {

    if (!response) throw new Error("Argument 'response' is invalid");

    //Trace instance of current function
    //and set instance of response
    var self = this;
    self.response = response;
    self.handledStates = [];

    //Handle for 'Ok'
    self.ok = function () {
        self.handledStates.push(handleOperationOk);
        return self;
    };

    self.entityCreated = function () {
        self.handledStates.push(handleEntityCreated);
        return self;
    };

    self.entityalreadyExists = function () {
        self.handledStates.push(handleEntityalreadyExists);
        return self;
    };

    //Handle for 'Badrequest'
    self.badRequest = function () {
        self.handledStates.push(handleOperationBadRequest);
        return self;
    };

    //Handle for 'Unauthorized'
    self.unauthorized = function () {
        self.handledStates.push(handleOperationUnauthorized);
        return self;
    };

    // 403 - Not authorized for this operation.
    self.unauthorizedOnOperation = function () {
        self.handledStates.push(handleUnauthorizedOnOperation);
        return self;
    };
    //Handle for 'InternalServerError'
    self.internalServerError = function () {
        self.handledStates.push(handleInternalServerError);
        return self;
    };

    //Handle for 'serviceNotAvailable'
    self.serviceNotAvailable = function () {
        self.handledStates.push(handleServiceNotAvailable);
        return self;
    };

    self.associationExpansionError = function () {
        self.handledStates.push(handleAssociationExpansionError);
        return self;
    };

    //Handle all
    self.all = function () {
        self.ok();
        self.entityCreated();
        self.entityalreadyExists();
        self.badRequest();
        self.unauthorized();
        self.internalServerError();
        self.serviceNotAvailable();
        self.unauthorizedOnOperation();
        self.associationExpansionError();
        return self;
    }

    //Execute pipeline
    self.pipe = function () {
        //Iterate each queued function
        for (var i = 0; i < self.handledStates.length; i++) {

            //Get current function
            var currentFunc = self.handledStates[i];

            //Invoke passing "response"
            currentFunc(self.response);
        }
    }

    //Returns self
    return self;
}

/**
 * Handles user - echo responses
 * @param {} response Response
 */
export function handleSignInResponse(response) {

    //Arguments validation
    if (!response) throw new Error("Argument 'response' is invalid");

    //Trace instance of current function
    //and set instance of response
    var self = this;
    self.response = response;
    self.handledStates = [];

    //Handle for 'Ok'
    self.ok = function () {
        self.handledStates.push(handleOperationOk);
        return self;
    };

    //Handle for 'Badrequest'
    self.badRequest = function () {
        self.handledStates.push(handleOperationBadRequest);
        return self;
    };

    //Handle for 403 'Forbidden'
    self.forbiddenRequest = function () {
        self.handledStates.push(handleUserLocked);
        return self;
    };

    //Handle for 'NotFound'
    self.notFound = function () {
        self.handledStates.push(handleUserNotFound);
        return self;
    };

    //Handle for 'Unauthorized'
    self.unauthorized = function () {
        self.handledStates.push(handleUserUnauthorized);
        return self;
    };

    //Handle for 'InternalServerError'
    self.internalServerError = function () {
        self.handledStates.push(handleInternalServerError);
        return self;
    };

    //Handle for 'serviceNotAvailable'
    self.serviceNotAvailable = function () {
        self.handledStates.push(handleServiceNotAvailable);
        return self;
    };

    //Handle all
    self.all = function () {
        self.ok();
        self.badRequest();
        self.forbiddenRequest();
        self.notFound();
        self.unauthorized();
        self.internalServerError();
        self.serviceNotAvailable();
        return self;
    }

    //Execute pipeline
    self.pipe = function () {

        //Iterate each queued function
        for (var i = 0; i < self.handledStates.length; i++) {

            //Get current function
            var currentFunc = self.handledStates[i];

            //Invoke passing "response"
            currentFunc(self.response);
        }
    }

    //Returns self
    return self;
}


// WEBPACK FOOTER //
// ./src/services/apis/serverErrorServices.js